// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
require('./_set-collection-of')('Set');



//////////////////
// WEBPACK FOOTER
// /Users/cully/projects/Jobs/abound/~/core-js/modules/es7.set.of.js
// module id = ../../node_modules/core-js/modules/es7.set.of.js
// module chunks = 18